<template>
  <div class="profile-projects">
    <div v-if="store.getters.enableCompetencies">
      <performer-competencies
        ref="projectCompetenciesRef"
        :title="'Карта моих компетенций'"
      />
    </div>
    <div v-if="store.getters.enableQualities">
      <performer-qualities />
    </div>
    <div v-if="store.getters.enableScientificScopes">
      <scientific-scopes title="УДК проектов, в которых есть опыт участия" />
    </div>
    <profile-table-layout
      :title="'Проекты, в которых я был руководителем'"
      :get-items="api.project.profileProjects"
      :url-params="urlParamsAsLeader"
      entity="projects"
    >
      <template #table-item="slotProps">
        <profile-projects-as-leader-item :item="slotProps.item" />
      </template>
    </profile-table-layout>
    <profile-table-layout
      :title="'Проекты, в которых я был исполнителем'"
      :get-items="api.project.profileProjects"
      :url-params="urlParamsAsPerformer"
      entity="projects"
    >
      <template #table-item="slotProps">
        <profile-projects-as-performer-item :item="slotProps.item" />
      </template>
    </profile-table-layout>
  </div>
</template>

<script setup>
  import PerformerCompetencies from '@/components/profile/projects/competencies/PerformerCompetencies.vue';
  import store from '@/store';
  import PerformerQualities from '@/components/profile/projects/qualities/PerformerQualities.vue';
  import ScientificScopes from '@/components/profile/projects/scientific-scopes/ScientificScopes.vue';
  import ProfileTableLayout from '@/components/profile/ProfileTableLayout.vue';
  import { useApi } from '@/api/use-api';
  import { USER_ROLE_LEADER, USER_ROLE_PERFORMER } from '@/api/models/UserRole';
  import ProfileProjectsAsLeaderItem from '@/components/profile/projects/as-leader/ProfileProjectsAsLeaderItem.vue';
  import ProfileProjectsAsPerformerItem from '@/components/profile/projects/as-performer/ProfileProjectsAsPerformerItem.vue';
  import { PROFILE_PROJECT_STATE_ARCHIVE } from '@/constants/profile-project-state';

  const api = useApi();
  const urlParamsAsLeader = new URLSearchParams({
    asRole: USER_ROLE_LEADER,
    state: PROFILE_PROJECT_STATE_ARCHIVE,
  });
  const urlParamsAsPerformer = new URLSearchParams({
    asRole: USER_ROLE_PERFORMER,
    state: PROFILE_PROJECT_STATE_ARCHIVE,
  });
</script>

<style lang="scss" scoped>
  .profile-projects {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-bottom: 100px;
  }
</style>
